import ContentBox from "components/ContentBox";
import React, { useState } from "react";
import Layout from "components/Layout";
import Calculation from "./Calculation";
import Result from "./Result";
import { useTranslation } from "react-i18next";

const Dashboard = () => {
  const { t } = useTranslation();
  const [result, setResult] = useState({
    pesimistic: 0,
    neutral: 0,
    optimistic: 0,
  });

  return (
    <Layout>
      <ContentBox className="small">
        <Calculation onCalculationComplete={(res) => {setResult(res)} } />
      </ContentBox>
      <ContentBox className="large">
        <Result result={result} />
      </ContentBox>
      <div style={{marginTop: "1em"}}>
        <p>{t("dashboard.bottom.info")} <a href="https://www.dnb.nl/voor-de-sector/open-boek-toezicht/sectoren/pensioenfondsen/dnb-publiceert-definitieve-scenariosets-bij-wet-toekomst-pensioenen/">{t("dashboard.bottom.here")}</a></p>
      </div>
    </Layout>
  );
};
export default Dashboard;
